import React from 'react';
export function HeroSection() {
  return <section className="relative bg-navy pt-24 pb-14 md:pt-32 md:pb-20 px-4 overflow-hidden" data-id="element-225">
      {/* Background gradient/glow */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-226">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-navy-light rounded-full blur-[120px] opacity-50" data-id="element-227"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] bg-navy-dark rounded-full blur-[120px] opacity-80" data-id="element-228"></div>
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 items-center relative z-10" data-id="element-229">
        {/* Left Column: Copy */}
        <div className="lg:col-span-7 text-center lg:text-left" data-id="element-230">
          <div className="inline-block mb-4 md:mb-5" data-id="element-231">
            <span className="inline-block border border-gold/30 bg-gold/10 text-gold text-xs md:text-sm font-bold tracking-widest uppercase px-4 py-1.5 rounded-full" data-id="element-232">
              EBOOK + 3 BONOS PRÁCTICOS · DESCARGA INMEDIATA
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white leading-[1.15] mb-4 text-balance" data-id="element-233">
            Hay un proceso silencioso dentro de tu cuerpo conectado con el
            azúcar en tu sangre.
          </h1>

          <p className="text-lg md:text-xl text-cream/90 font-serif italic leading-relaxed mb-3" data-id="element-234">
            Se llama glicación. No duele. No avisa. Pero cada día que pasa sin
            entenderlo, tus órganos están pagando un precio que no ves.
          </p>

          <p className="text-base md:text-lg text-cream/70 font-sans font-light leading-relaxed mb-6 max-w-2xl mx-auto lg:mx-0" data-id="element-235">
            Este ebook te explica — en español simple y basado en ciencia — qué
            está ocurriendo y exactamente qué puedes hacer. Sin dietas extremas.
            Sin contar calorías.
          </p>

          <div className="flex flex-col items-center lg:items-start gap-3" data-id="element-236">
            <a href="https://www.godeskcore.com/cart/42794527916080:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto" data-id="element-237">
              <button className="w-full md:w-auto bg-cta hover:bg-cta-hover text-white font-bold text-base md:text-lg py-4 px-8 rounded-lg transition-all duration-300 shadow-[0_4px_14px_0_rgba(200,16,46,0.39)] hover:shadow-[0_6px_20px_rgba(200,16,46,0.23)] hover:-translate-y-0.5 flex items-center justify-center gap-2" data-id="element-238">
                <span data-id="element-239">🔒 DESCARGAR EBOOK + 3 BONOS — $17.95</span>
              </button>
            </a>
            <p className="text-xs md:text-sm text-cream/60 font-sans" data-id="element-240">
              Acceso inmediato · 4 PDFs descargables · Tuyos para siempre · Pago
              seguro
            </p>
          </div>
        </div>

        {/* Right Column: Visual */}
        <div className="lg:col-span-5 flex flex-col items-center justify-center mt-8 lg:mt-0" data-id="element-241">
          {/* Book Mockup */}
          <div className="relative w-56 md:w-72 transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-242">
            <img src="https://cdn.magicpatterns.com/uploads/ppS9QAGMaXBJbjuasxX9DD/Portada_imagen_de_libro_-_Ebook1.png" alt="Portada del Ebook El Azúcar Silencioso por Roderic Guillen" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-243" />
          </div>

          {/* Social Proof */}
          <div className="flex flex-col items-center gap-2" data-id="element-244">
            <div className="flex gap-1 text-gold" data-id="element-245">
              <span data-id="element-246">★</span>
              <span data-id="element-247">★</span>
              <span data-id="element-248">★</span>
              <span data-id="element-249">★</span>
              <span data-id="element-250">★</span>
            </div>
            <p className="text-cream/80 font-sans text-sm" data-id="element-251">
              <span className="font-bold" data-id="element-252">4.9/5</span> · +2,400 lectores
            </p>
          </div>

          {/* Secondary Hero Image */}
          <div className="mt-4 w-full max-w-sm mx-auto lg:mx-0" data-id="element-253">
            <img src="https://cdn.magicpatterns.com/uploads/fHsd4ZQBtye4dFFa8BSwAm/Imagen_Segundaria_del_Hero.png" alt="Mujer leyendo el ebook El Azúcar Silencioso" className="w-full h-auto rounded-xl shadow-lg" data-id="element-254" />
          </div>
        </div>
      </div>
    </section>;
}